import Icon from '../components/Icon.vue'

Icon.register({
  trash: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 84V56C0 42.7 10.7 32 24 32H136L145.4 13.3C149.4 5.1 157.7 0 166.8 0H281.1C290.2 0 298.5 5.1 302.6 13.3L312 32H424C437.3 32 448 42.7 448 56V84C448 90.6 442.6 96 436 96H12C5.4 96 0 90.6 0 84zM415.2 140.7L394.8 467C393.2 492.3 372.2 512 346.9 512H101.1C75.8 512 54.8 492.3 53.2 467L32.8 140.7C32.4 133.8 37.9 128 44.8 128H403.3C410.1 128 415.6 133.8 415.2 140.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/trash.js
// module id = zxa9
// module chunks = 144